import React, { Component, Context } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import debounce from "lodash.debounce";
import IconButton from "@material-ui/core/IconButton";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { WidgetProps } from "../widgets";
import { IGalleryActionDispatches, mapGalleryDispatchToProps } from "../../redux/actions/gallery";
import { IGalleryState, mapGalleryStateToProps } from "../../redux/reducers/gallery";
import { ISiteGalleryContent, IEditableWidget } from "../../models/cms";
import { IImage, ImageMedia, getSiteMedia } from "../../models/Image";
import ImageThumbnails from "../ui/Media/ImageThumbnails";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { getGalleryImageDimensions, getContainerWidth } from "../../models/layout";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { getDateDisplay } from "../../utils/date-utils";
import "./Gallery.scss";

//   <ImageThumbnails images={this.props.images} className={(!this.props.galleryView ? "preview" : "") + " mt-4 my-2 animated fadeIn"} />

class GalleryWidget extends Component<
	IGalleryActionDispatches & IGalleryState & WidgetProps & IEditableWidget & { renderMobileLayout?: boolean },
	any
> {
	private readonly handleScroll = debounce(this.onScroll.bind(this), 5, { trailing: true });
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		galleryScrollLeft: 0,
	};

	get gallery(): ISiteGalleryContent {
		if (this.props.editWidget) return this.props.editWidget;
		if (!this.props.page || !this.props.page.id) return null;
		return (this.props.galleries || []).find((c: ISiteGalleryContent) => c.id === this.props.page.galleryId);
	}

	componentDidMount() {
		if (!this.props.editWidget) this.props.loadGalleries();
	}

	onScroll(e) {
		if (!this.gallery) return;
		const el = document.getElementById(`gallery-container-${this.gallery.id}`);
		if (!el) return;
		this.setState({ galleryScrollLeft: el.scrollLeft });
		console.log("scrollLeft", el.scrollLeft);
	}

	doScroll(value: number) {
		const el = document.getElementById(`gallery-container-${this.gallery.id}`);
		if (!el) return;
		el.scroll({ left: this.state.galleryScrollLeft + value });
	}

	render() {
		const gallery: ISiteGalleryContent = this.gallery;
		if (!gallery) return null;
		console.log("gallery loaded:", gallery);
		const imageDimensions = getGalleryImageDimensions(
			this.props.renderMobileLayout
				? { isDesktopRes: false, isMobileOrTabletDevice: true, isMobileOrTabletRes: true, isMobileRes: true }
				: this.context.settings
		);
		const siteImages: IImage[] = (gallery.media || []).map((m: IImage) =>
			getSiteMedia(m, "galleries", gallery.folder)
		);
		const editable: boolean = !!this.props.editWidget;

		return (
			<LayoutContext.Provider value={{ ...this.context, ...imageDimensions }}>
				<div className="w-100 bg-black position-relative">
					<div
						className={clsx(
							!this.props.isNested && "container",
							!this.props.page?.noPadding && "section-padding",
							"white-side-right1 position-relative gallery-section-container"
						)}
					>
						<h1
							className={clsx("highlighted text-white mb-5", editable && "cms-editable-field")}
							contentEditable={editable}
							data-cms-field="title"
							onBlur={this.props.onInput}
						>
							{gallery.title}
						</h1>
						<div
							className="position-absolute gallery-arrow arrow-right"
							style={{ marginTop: `${imageDimensions.imageHeight / 2 - 25}px` }}
						>
							<IconButton
								edge="start"
								onClick={(e) => {
									e.preventDefault();
									this.doScroll(getContainerWidth(this.props.renderMobileLayout ? 400 : undefined));
								}}
								disabled={
									this.state.galleryScrollLeft >=
									(gallery.media.length || 0) * (imageDimensions.imageWidth + 15) -
										15 -
										getContainerWidth(this.props.renderMobileLayout ? 400 : undefined)
								}
							>
								<ArrowForwardIosIcon />
							</IconButton>
						</div>
						<div
							className="position-absolute gallery-arrow arrow-left"
							style={{ marginTop: `${imageDimensions.imageHeight / 2 - 25}px` }}
						>
							<IconButton
								edge="start"
								onClick={(e) => {
									e.preventDefault();
									this.doScroll(-getContainerWidth(this.props.renderMobileLayout ? 400 : undefined));
								}}
								disabled={this.state.galleryScrollLeft === 0}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</div>
						<div
							id={`gallery-container-${gallery.id}`}
							className="scrolling-wrapper-flexbox scrolling-wrapper"
							onScroll={this.handleScroll}
						>
							{siteImages.map((media: IImage, i: number) => {
								return (
									<div
										key={i}
										style={{ maxWidth: imageDimensions.imageWidth }}
										className="mb-4 scroll-card"
									>
										<ImageEnlarge
											image={media}
											width={imageDimensions.imageWidth}
											height={imageDimensions.imageHeight}
											displayThumb={true}
											galleryImages={siteImages}
											selectedMediaIndex={i}
											scaleInEffect
										/>
										<div className="text-gray text-uppercase text-sm mt-4 mb-1">
											{getDateDisplay(media.mediaDate, null)}
										</div>
										<h3
											className={clsx("subheading text-white", editable && "cms-editable-field")}
											contentEditable={editable}
											data-cms-field={`media[${i}.title]`}
											onBlur={this.props.onInput}
										>
											{media.title}
										</h3>
									</div>
								);
							})}
						</div>
						<NavLink to={`/gallery/${gallery.id}`} className="d-inline-block w-100 text-center mt-1">
							<button className="btn btn-primary py-2 w-100-xs">View All Images</button>
						</NavLink>
					</div>
				</div>
			</LayoutContext.Provider>
		);
	}
}

export default connect<IGalleryState, IGalleryActionDispatches, WidgetProps>(
	mapGalleryStateToProps,
	mapGalleryDispatchToProps
)(GalleryWidget);
